import { ICourseCertificate, ICourseCertificateDesign, ICreateCourseCertificate } from '@/types/courses';
import { Certificate } from './types';

export const GenerateMockCertificate = (
  selectedDesign: ICourseCertificateDesign,
  cert: ICreateCourseCertificate | ICourseCertificate | undefined
): Certificate => {
  return {
    ...selectedDesign,
    ...MockCertificate,
    settings: { ...selectedDesign.settings, icon: cert?.settings.icon },
  };
};

export const MockCertificate: Certificate = {
  userName: 'Amalia Stone',
  email: 'amaliastone@brandlive.com',
  blProfileId: 47,
  certificateName: 'Certificate of Marketing Excellence',
  dateString: 'June 20th, 2025',
  byline: 'has been recognized for achievement with',
  credits: 10,
  categories: ['Taxes & Accounting', 'Economics'],
  settings: {
    id: 'gold',
    fonts: {
      byline: {
        url: 'https://assets.brandlive.com/assets/certificates/Barlow-Regular.ttf',
        font: 'Barlow-Regular',
        size: '21px',
        style: 'italic',
      },
      default: 'Barlow-Regular',
      userName: {
        url: 'https://assets.brandlive.com/assets/certificates/Carattere-Regular.ttf',
        font: 'Carattere',
        size: '90px',
      },
      dateString: {
        url: 'https://assets.brandlive.com/assets/certificates/Roboto-Regular.ttf',
        font: 'Roboto-Regular',
        size: '20px',
        letterSpacing: '6px',
      },
      default_url: 'https://assets.brandlive.com/assets/certificates/Barlow-Regular.ttf',
      certificateName: {
        url: 'https://assets.brandlive.com/assets/certificates/Roboto-Regular.ttf',
        font: 'Roboto-Regular',
        size: '30px',
        letterSpacing: '6px',
      },
      credits: {
        font: 'Roboto-Regular',
        url: 'https://assets.brandlive.com/assets/certificates/Roboto-Regular.ttf',
        size: '20px',
        letterSpacing: '6px',
      },
      categories: {
        font: 'Roboto-Regular',
        url: 'https://assets.brandlive.com/assets/certificates/Roboto-Regular.ttf',
        size: '20px',
        letterSpacing: '6px',
      },
    },
    colors: {
      text: '#022449',
      accent1: '#B98D35',
      accent2: '#E7CA86',
      accent3: '#E8E9E9',
      dateColor: 'text',
      background: 'white',
      titleColor: 'accent1',
      userNameColor: 'text',
      certificateNameColor: 'accent1',
      creditColor: 'text',
      categoriesColor: 'text',
    },
    positions: {
      icon: {
        x: 57,
        y: 39,
        width: 48,
        height: 48,
      },
      byline: {
        x: 834,
        y: 236,
      },
      userName: {
        x: 834,
        y: 200,
      },
      dateString: {
        x: 834,
        y: 440,
      },
      certificateName: {
        x: 834,
        y: 332,
      },
      credits: {
        x: 834,
        y: 503,
      },
      categories: {
        x: 834,
        y: 513,
      },
    },
    backgroundImage: 'https://assets.brandlive.com/assets/certificates/cert-bg-gold.jpg',
  },
};

export const MockCertificate2: Certificate = {
  userName: 'Amalia Stone',
  email: 'amaliastone@brandlive.com',
  blProfileId: 47,
  certificateName: 'Certificate of Marketing Excellence',
  dateString: 'June 20th, 2025',
  byline: 'has been recognized for achievement with',
  credits: 10,
  categories: ['Taxes & Accounting', 'Economics'],
  settings: {
    id: 'purple',
    fonts: {
      byline: {
        url: 'https://assets.brandlive.com/assets/certificates/Poppins-Regular.ttf',
        font: 'Poppins-Regular',
        size: '15px',
        letterSpacing: '3px',
      },
      default: 'Poppins-Regular',
      userName: {
        url: 'https://assets.brandlive.com/assets/certificates/Poppins-Regular.ttf',
        font: 'Poppins-Regular',
        size: '72px',
      },
      dateString: {
        url: 'https://assets.brandlive.com/assets/certificates/Poppins-Light.ttf',
        font: 'Poppins-Light',
        size: '25px',
      },
      default_url: 'https://assets.brandlive.com/assets/certificates/Poppins-Regular.ttf',
      certificateName: {
        url: 'https://assets.brandlive.com/assets/certificates/Poppins-Light.ttf',
        font: 'Poppins-Light',
        size: '35px',
      },
      credits: {
        url: 'https://assets.brandlive.com/assets/certificates/Poppins-Light.ttf',
        font: 'Poppins-Light',
        size: '25px',
      },
      categories: {
        url: 'https://assets.brandlive.com/assets/certificates/Poppins-Light.ttf',
        font: 'Poppins-Light',
        size: '25px',
      },
    },
    colors: {
      text: 'white',
      accent1: '#9E7DE9',
      accent2: 'white',
      accent3: 'white',
      dateColor: 'accent1',
      background: 'black',
      titleColor: 'text',
      userNameColor: 'text',
      certificateNameColor: 'text',
      creditColor: 'accent1',
      categoriesColor: 'accent1',
    },
    positions: {
      icon: {
        x: 90,
        y: 50,
        width: 48,
        height: 48,
      },
      byline: {
        x: 834,
        y: 216,
      },
      userName: {
        x: 834,
        y: 165,
      },
      dateString: {
        x: 834,
        y: 460,
      },
      certificateName: {
        x: 834,
        y: 316,
      },
      credits: {
        x: 834,
        y: 540,
      },
      categories: {
        x: 834,
        y: 550,
      },
    },
    backgroundImage: 'https://assets.brandlive.com/assets/certificates/cert-bg-purple.png',
  },
};
